import React from "react"

const Prose = ({ children }) => (
  <article className="prose prose-gray prose-lg max-w-none prose-emerald prose-a:text-emerald-700 dark:prose-a:text-emerald-400 dark:prose-invert dark:prose-hr:border-gray-600 dark:prose-tr:border-gray-600">
    {children}
  </article>
)

export default Prose
